import React from "react";
import { Search, Share2, ChartBar, Target, ArrowRight, Smartphone, Mail, Globe, Calculator, FileText, FileBadge as CertificateIcon } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardTitle, CardDescription, CardFooter } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Redovisning",
  description: "Vi tar rollen som er ekonomiavdelning – med framförhållning, precision och ert bästa i fokus.",
  icon: CertificateIcon,
  link: "/OurOfferPage",
  image: "https://logikekonomi.se/wp-content/uploads/2026/04/Redovisning.png?v=fl5fu9phx2w"
}, {
  title: "Lön",
  description: "Vi erbjuder mer än lönehantering – ni får en erfaren partner med bred kompetens.",
  icon: FileText,
  link: "/OurOfferPage",
  image: "https://logikekonomi.se/wp-content/uploads/2026/04/Lon.png?v=ndt06q9nhw8"
}, {
  title: "Rådgivning",
  description: "Kvalificerat stöd i affärsutveckling och ekonomisk planering för att maximera din lönsamhet.",
  icon: Target,
  link: "/OurOfferPage",
  image: "https://logikekonomi.se/wp-content/uploads/2026/04/Radgivning.png?v=7c67vo1khfw"
}, {
  title: "Affärssystem",
  description: "Implementering och optimering av moderna molnbaserade system som förenklar din vardag.",
  icon: Globe,
  link: "/OurOfferPage",
  image: "https://logikekonomi.se/wp-content/uploads/2026/04/Affarssystem-1.png?v=lu5og8kvpbs"
}, {
  title: "Ekonomistyrning",
  description: "Budgetering, prognoser och kassaflödesanalys som ger dig full kontroll över företagets framtid.",
  icon: Search,
  link: "/OurOfferPage",
  image: "https://logikekonomi.se/wp-content/uploads/2026/04/Ekonomistyrning.png?v=wp50yr5ko1p"
}, {
  title: "Skatterådgivning",
  description: "Expertis inom skattefrågor för både företag och ägare för att optimera den totala skattesituationen.",
  icon: Target,
  link: "/OurOfferPage",
  image: "https://logikekonomi.se/wp-content/uploads/2026/04/Skatteradgivning.png?v=b2esgnrxp74"
}];
export default function SpecialistAreas() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="67076" id="vår-expertis" ref={ref} className="section bg-[#F7F8FA] text-foreground relative overflow-hidden ![padding:20px_48px_40px_48px]">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-7xl pointer-events-none">
        <div className="absolute top-20 left-20 w-64 h-64 bg-primary/5 rounded-full blur-3xl opacity-10" />
        <div className="absolute bottom-20 right-20 w-96 h-96 bg-primary/5 rounded-full blur-3xl opacity-10" />
      </div>

      <div className="container relative z-10 mx-auto">
        <div className={`mb-16 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          
        </div>

        <div className={`text-center max-w-3xl mx-auto mb-16 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          
          
        </div>

        <h2 className="h2 text-primary font-bold mb-12 transition-all duration-700 delay-100 opacity-100 translate-y-0 !text-4xl">Vad behöver ditt företag?</h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 justify-center">
          {services.map((service, i) => <div key={i} data-index={i} className={`transition-all duration-700 delay-[${i * 100}ms] ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
              <Link to={service.link} className="block h-full group/card">
                <Card className="h-full bg-white shadow-sm hover:shadow-md hover:-translate-y-1 rounded-lg p-8 transition-all duration-300 cursor-pointer border border-border/40 flex flex-col group">
                  <img src={service.image} alt={service.title} className="object-cover rounded-sm !h-[100px] !w-[110px]" />
                  <CardHeader className="px-0 pt-0 flex flex-row items-center gap-4">
                    <CardTitle className="text-2xl font-bold text-primary transition-colors duration-300">
                      {service.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="px-0 flex-grow">
                    <CardDescription className="body text-muted-foreground/70 leading-[var(--line-height-body)]">
                      {service.description}
                    </CardDescription>
                  </CardContent>
                  <CardFooter className="px-0 pb-0 border-t border-border/40 mt-auto pt-6">
                    <div className="inline-flex items-center text-sm font-medium text-muted-foreground group-hover:text-accent transition-colors duration-300">
                      Läs mer
                      <ArrowRight className="ml-2 w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
                    </div>
                  </CardFooter>
                </Card>
              </Link>
            </div>)}
        </div>
      </div>
    </section>;
}